module.exports = __webpack_public_path__ + "img/chat.51438f1c.svg";